import React, { useCallback, useMemo } from "react";
import { houseIdPrefixLabelValueSets } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { userAccountRoleList } from "../../../../domain/user/account/UserAccountRole";
import { useAppDispatch } from "../../../../state/store";
import { houseIdFilterAction, roleFilterAction } from "../../../../state/usecase/admin/login_log/actions";
import { useFilteredLoginLogList } from "../../../hooks/admin/login_log/useFilteredLoginLogList";
import { InputCheckBox } from "../../common/input/InputCheckBox";

export const LoginLogFilter = React.memo(function LoginLogFilter() {
    const dispatch = useAppDispatch();

    const { roleConditions, houseIdPrefixConditions } = useFilteredLoginLogList();

    const roleInputList = useMemo(() => userAccountRoleList.map(role => role), []);

    const handleRoleFilterChanged = useCallback((role: string) => () => {
        dispatch(roleFilterAction({ role: role }));
    }, [dispatch]);

    const handleHouseIdFilterChanged = useCallback((houseIdPrefix: string) => () => {
        dispatch(houseIdFilterAction({ houseIdPrefix: houseIdPrefix }));
    }, [dispatch]);

    return (
        <div className={"filter_area"}>
            {/* 対象ユーザー */}
            <div className={"role"}>
                <div className={"title"}>権限：</div>
                {roleInputList.map(roleInput => (
                    <InputCheckBox
                        key={roleInput.value}
                        label={roleInput.label}
                        value={roleInput.value}
                        checked={roleConditions.includes(roleInput.value)}
                        handleCheckBoxChanged={handleRoleFilterChanged(roleInput.value)}
                    />
                ))}
            </div>
            {/* 紐づいている利用者のハウスIDプレフィクス */}
            <div className={"house_id_prefix"}>
                <div className={"title"}>ハウスID：</div>
                {houseIdPrefixLabelValueSets.map(houseId => (
                    <InputCheckBox
                        key={houseId.value}
                        label={houseId.label}
                        value={houseId.value}
                        checked={houseIdPrefixConditions.includes(houseId.value)}
                        handleCheckBoxChanged={handleHouseIdFilterChanged(houseId.value)}
                    />
                ))}
            </div>
        </div>
    );
});